import client from 'services';

export async function getUsers() {
  return await client({ method: 'get', url: '/users' });
}
